export default __webpack_public_path__ + "static/media/clothing_sweater.651d7351.svg";